import BigNumber from 'bignumber.js';

import { InterestModel } from 'types/contracts';

export interface IGetBRTokenSupplyRateInput {
  interestModelContract: InterestModel;
  cashAmountWei: BigNumber;
  borrowsAmountWei: BigNumber;
  reservesAmountWei: BigNumber;
  reserveFactorMantissa: BigNumber;
}

export type IGetBRTokenSupplyRateOutput = BigNumber;

const getBRTokenSupplyRate = async ({
  interestModelContract,
  cashAmountWei,
  borrowsAmountWei,
  reservesAmountWei,
  reserveFactorMantissa,
}: IGetBRTokenSupplyRateInput): Promise<IGetBRTokenSupplyRateOutput> => {
  const supplyRate = await interestModelContract.methods
    .getSupplyRate(
      cashAmountWei.toFixed(),
      borrowsAmountWei.toFixed(),
      reservesAmountWei.toFixed(),
      reserveFactorMantissa.toFixed(),
    )
    .call();
  return new BigNumber(supplyRate);
};
export default getBRTokenSupplyRate;
